import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { searchResultsAtom } from './trpcSearchResultState';
import { RootFolderTree } from '@workspace/view-model-folder/domain/FolderTree';
import { SearchWorkspaceItem } from './SearchWorkspaceItem';

export const SearchResult: React.FC = () => {
  const { t } = useTranslation();
  const trpcResults = useAtomValue(searchResultsAtom);

  const sortedWorkspaces = useMemo(() => {
    if (!trpcResults || !trpcResults.results.workspaces) return [];

    return Object.values(trpcResults.results.workspaces).sort((a, b) => a.name.localeCompare(b.name));
  }, [trpcResults]);

  if (sortedWorkspaces.length === 0) return null;

  return (
    <div className="mb-4">
      <div className="text-xs font-bold">{t('sidebar.searchResult.label')}</div>
      <div className="ml-4">
        {sortedWorkspaces.map((workspace) => {
          const rootFolderTree = RootFolderTree.load(trpcResults.results.folderTrees[workspace.id] || {});
          return <SearchWorkspaceItem key={workspace.id} workspace={workspace} rootFolderTree={rootFolderTree} />;
        })}
      </div>
    </div>
  );
};
